<template>
  <page
    :sidebar="sidebar"
    :search="search"
    :searchItems="searchItems"
    :toolbar="toolbar"
    :loading="loading"
    v-on:add="add"
    v-on:save="save"
    v-on:clear="clear"
    v-on:remove="remove"
  >
    <template v-slot:sidebar>
      <v-toolbar dense flat>
        <v-btn icon :disabled="search.page < 2" @click="prevPage">
          <font-awesome-icon icon="chevron-left" class="my-1" />
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn icon @click="nextPage">
          <font-awesome-icon icon="chevron-right" class="my-1" />
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <div class="text-caption text--disabled d-flex justify-center">
        <span>Page: {{ search.page }}</span>
      </div>

      <v-alert
        v-if="invoices.items.length == 0"
        text
        outlined
        color="orange"
        icon="mdi-alert"
        >No matching invoices</v-alert
      >

      <v-list v-else shaped>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item
            v-for="(item, i) in invoices.items"
            :key="i"
            @click="view(item)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.client.name"></v-list-item-title>

              <v-list-item-subtitle>
                <div class="d-flex" style="justify-content: space-between">
                  <div>
                    <div>{{ moment(item.date).format("DD/MM/YY") }}</div>
                    <div>{{ `£ ${Math.abs(item.subtotal).toFixed(2)}` }}</div>
                    <div>{{ `£ ${Math.abs(item.vat).toFixed(2)}` }}</div>
                  </div>
                  <div>
                    <div>
                      No:
                      <span class="subtitle-2">{{ item.invoiceNo }}</span>
                    </div>
                    <div v-if="item.subtotal < 0">CREDIT</div>
                  </div>
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </template>

    <template v-slot:content>
      <div>
        <!-- <v-card>
          <pdf :invoice="item"></pdf>
        </v-card>-->
        <v-tabs
          show-arrows
          v-model="tab"
          background-color="grey lighten-5"
          color="primary"
          center-active
        >
          <v-tab
            v-for="(item, index) in tabItems"
            :key="index"
            :disabled="isDisabled(index)"
          >
            <v-badge
              color="red"
              :content="item.badge"
              :value="item.badge > 0"
              >{{ item.title }}</v-badge
            >
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-container fluid>
              <v-row
                align="center"
                :justify="breakpoint.md ? 'center' : 'start'"
                dense
              >
                <v-col cols="12" sm="6" md="4" lg="3" v-if="isNew">
                  <v-autocomplete
                    v-model="item.client"
                    :items="clientsWithBookings"
                    label="Client"
                    persistent-hint
                    item-text="name"
                    return-object
                    filled
                    outlined
                    hide-details
                    :readonly="!isNew"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="3" v-if="!isNew">
                  <v-text-field
                    :value="item.client.name"
                    label="Client"
                    outlined
                    readonly
                    filled
                    hide-details
                  ></v-text-field>
                </v-col>

                <v-col cols="auto">
                  <v-text-field
                    v-if="!isNew"
                    v-model="item.invoiceNo"
                    label="Invoice No"
                    outlined
                    type="number"
                    filled
                    hide-details
                    style="width: 100px; float: left"
                    class="mr-2"
                  ></v-text-field>

                  <v-text-field
                    v-if="!isNew"
                    v-model="item.purchaseOrderNo"
                    label="PO No"
                    placeholder="#"
                    outlined
                    filled
                    hide-details
                    style="width: 100px; float: left"
                    class="mr-2"
                  ></v-text-field>

                  <date
                    v-model="item.date"
                    :style="'width:100px;float:left'"
                    label="Invoice Date"
                    class="mr-2"
                  ></date>
                  <date
                    v-model="item.start"
                    :startOf="true"
                    :style="'width:100px;float:left'"
                    label="Start"
                    class="mr-2"
                  ></date>
                  <date
                    v-model="item.finish"
                    :endOf="true"
                    :style="'width:100px;float:left'"
                    label="Finish"
                    class="mr-2"
                  ></date>
                </v-col>
              </v-row>
              <v-row
                dense
                align="end"
                v-if="existingInvoices.length > 0 && item.client"
              >
                <v-col cols="1">
                  <div style="text-align: right">Add To:</div>
                </v-col>
                <v-col cols="11" sm="5" md="3" lg="2">
                  <v-autocomplete
                    v-model="existingInvoice"
                    :items="existingInvoices"
                    label="Existing Invoices"
                    persistent-hint
                    item-text="invoiceNo"
                    return-object
                    filled
                    outlined
                    hide-details
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <invoice :invoice="item" class="mt-2"></invoice>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <blank-invoice :invoice="item"></blank-invoice>
          </v-tab-item>
          <v-tab-item>
            <credit-note :invoice="item"></credit-note>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </template>
  </page>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment, { min } from "moment";

import invoice from "./invoice";
import blankInvoice from "./blank_invoice";
import creditNote from "./credit_note";
import unallocatedBookings from "./unallocated_bookings";
import pdf from "@/components/pdf";
import date from "@/components/date";

export default {
  components: {
    invoice,
    blankInvoice,
    creditNote,
    unallocatedBookings,
    pdf,
    date,
  },
  data() {
    return {
      sidebar: {
        width: 250,
        visible: true,
        title: "Invoices",
        pinned: false,
        isHovering: false,
      },
      searchItems: ["Client", "Invoice #", "PO #"],
      search: {
        term: "",
        type: "Client",

        page: 1,
      },
      selectedItem: null,
      item: {},
      originalItem: {},
      isNew: true,
      isBlank: false,
      isCredit: false,
      tab: 0,
      existingInvoices: [],
      existingInvoice: null,
    };
  },
  watch: {
    isNew(val) {
      // this.tab = 0;
    },
    item(val) {
      console.log(val);
    },
    existingInvoice(val, oldVal) {
      if (val) {
        if (oldVal && val.invoiceNo == oldVal.invoiceNo) {
          return;
        }
        if (val.invoiceNo == "New") {
          // this.item.bookings = [];
          this.isNew = true;
          this.setClientBookings();
        } else {
          var items = this.item.dbBookings.filter((b) => !b.invoice);
          this.view(val, items);
        }
      }
    },
    "item.client": function (val, oldVal) {
      console.log(val);
      if (val != oldVal) {
        this.setClientBookings();
      }
    },
    "search.term"(val) {
      if (this.search.page != 1) {
        this.search.page = 1;
        return;
      }
      this.searchInvoices();
    },
    "search.type"(val) {
      if (this.search.page != 1) {
        this.search.page = 1;
        return;
      }
      this.searchInvoices();
    },
    "search.page"(val) {
      this.searchInvoices();
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      timesheets: (state) => state.timesheets,
      clients: (state) => state.clients,
      candidates: (state) => state.candidates,
      invoices: (state) => state.invoices,
      bookings: (state) => state.bookings,
    }),
    breakpoint() {
      console.log(this.$vuetify.breakpoint);
      return this.$vuetify.breakpoint;
    },
    loading() {
      return this.invoices.loading || this.bookings.loading;
    },
    isExistingInvoice() {
      return this.existingInvoice && this.existingInvoice._id;
    },

    clientsWithBookings() {
      var bookingClients = this.bookings.unallocatedInvoiceItems.map((b) => {
        return b.client._id;
      });
      return this.clients.items.filter((c) => {
        return bookingClients.includes(c._id);
      });
    },

    sites() {
      if (!this.item.client || !this.item.client.sites) {
        return [];
      }
      var items = [...this.item.client.sites];
      items.splice(0, 0, {
        name: "All",
      });
      return items;
    },

    tabItems() {
      return [
        {
          title: "Invoices",
          badge: this.clientsWithBookings.length,
        },
        {
          title: "Blank Invoice",
          badge: 0,
        },

        {
          title: "Credit Note",
          badge: 0,
        },
      ];
    },
    isValid() {
      var valid;
      if (this.isBlank || this.tab == 1) {
        valid = this.item.client != null && this.item.subtotal != 0;
      } else if (this.isCredit || this.tab == 2) {
        valid = this.item.client != null && this.item.subtotal != 0;
      } else {
        valid =
          this.item !== this.originalItem &&
          this.item.client != null &&
          this.item.bookings.length > 0;
      }
      return valid;
    },
    toolbar() {
      return {
        title: this.title,
        add: !this.isNew,
        save: this.isValid && this.canEdit,
        clear: this.isNew,
        delete: !this.isNew,
        deleteItem: "invoice",
      };
    },
    title() {
      var prefix = this.isNew ? "New " : "Edit ";
      var t =
        this.tab == 0
          ? "Invoice"
          : this.tab == 1
          ? "Blank Invoice"
          : "Credit Note";
      return prefix + t;
    },
    canEdit() {
      var val = "Invoices";
      var user = this.account.user;
      console.log("here");
      if (user.role != "user" || this.account.location.name == "Demo") {
        return true;
      }
      var role = user.roles.find((r) => {
        return r.location == this.account.location._id;
      });
      if (!role) {
        return false;
      }
      var permission = role.permissions.find((p) => {
        return p.name == val;
      });
      if (!permission) {
        return false;
      }
      if (permission.permission != 2) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions({
      fetchInvoices: "invoices/fetch",
      fetchRecentInvoicesByClient: "invoices/fetchRecentByClient",
      create: "invoices/create",
      update: "invoices/update",
      delete: "invoices/delete",
      fetchBookings: "bookings/fetchByInvoice",
      fetchUnallocatedBookings: "bookings/fetchUnallocatedInvoiceBookings",
      fetchClients: "clients/fetch",
    }),
    isDisabled(i) {
      return false;
      if (this.isBlank && i != 1) {
        return true;
      } else if (this.isCredit && i != 2) {
        return true;
      }
      return false;
    },
    otherDay(b) {
      return {
        _id: b._id,
        candidate: b.candidate,
        client: b.client,
        role: b.type,
        hours: b.quantity,
        rate: b.amount,
        bookingType: b.bookingType,
      };
    },

    bookingDay(b) {
      var minutes = moment(b.finish).diff(moment(b.start), "minutes");
      var breaks = 0;
      if (b.breaks && b.breaks.includes(":")) {
        var a = b.breaks.split(":");
        breaks = (+a[0] * 60 * 60 + +a[1] * 60) / 60;
      }
      var hours = (minutes - breaks) / 60;

      return {
        _id: b._id,
        candidate: b.candidate,
        date: b.start,
        client: b.client,
        role: b.role,
        rate: b.rate,
        site: b.site,
        info: b.info,
        hours: hours,
        bookingType: b.bookingType,
      };
    },

    add() {
      this.item = {};
      this.originalItem = {};
      this.isNew = true;
      this.listIndex = null;
      this.isBlank = false;
      this.isCredit = false;
    },
    async save() {
      console.log(this.item);

      var payload = {
        ...this.item,
        client: {
          _id: this.item.client._id,
          name: this.item.client.name,
        },
        bookings: this.item.filterBookings.map((b) => {
          return {
            _id: b._id,
            rate: b.rate,
          };
        }),
        expenses: this.item.filterExpenses.map((e) => {
          return {
            _id: e._id,
            amount: e.amount,
          };
        }),
        other: this.item.other,
      };

      if (this.tab == 2) {
        if (payload.subtotal > 0) {
          payload.subtotal = payload.subtotal * -1;
        }
        if (payload.vat > 0) {
          payload.vat = payload.vat * -1;
        }
      }

      this.isNew ? await this.create(payload) : await this.update(payload);
      this.fetchUnallocatedBookings();
      this.add();
    },
    clear() {},
    async remove() {
      await this.delete(this.item);
      this.fetchUnallocatedBookings();
      this.add();
    },

    async view(item, newBookings) {
      console.log(item);
      var bookings = await this.fetchBookings(item._id);

      if (newBookings) {
        bookings = [...newBookings, ...bookings];
      }

      console.log("Bookings");
      console.log(bookings);

      this.isNew = false;

      var bookingItems = bookings.filter((b) => b.bookingType == 0);
      var expenseItems = bookings.filter((b) => b.bookingType == 1);
      var otherItems = item.other;

      var sorted = bookingItems.sort(function (a, b) {
        return Date.parse(a.start) > Date.parse(b.start);
      });

      var start = item.start;
      var finish = item.finish;
      if (sorted.length > 0) {
        if (start == null) {
          start = moment(sorted[0].start).startOf("isoWeek").toISOString();
        }
        if (finish == null) {
          finish = moment(sorted[sorted.length - 1].start)
            .endOf("isoWeek")
            .toISOString();
        }
      }

      console.log(bookingItems);
      console.log(expenseItems);

      this.item = {
        ...item,
        dbBookings: bookings,
        start,
        finish,
        bookings: bookingItems.map((b) => {
          return this.bookingDay(b);
        }),
        expenses: expenseItems,
        other: otherItems,
        subtotal: Math.abs(item.subtotal),
        vat: Math.abs(item.vat),
      };

      console.log(this.item);
      this.originalItem = { ...this.item };

      if (bookings.length == 0) {
        if (item.subtotal > 0) {
          console.log("Blank");
          this.isBlank = true;
          this.isCredit = false;
          this.tab = 1;
        } else {
          this.isCredit = true;
          this.isBlank = false;
          this.tab = 2;
        }
        return;
      } else {
        this.isCredit = false;
        this.isBlank = false;
        this.tab = 0;
      }
    },

    alert(client) {
      return [];
    },
    nextPage() {
      this.search.page += 1;
    },
    prevPage() {
      this.search.page -= 1;
    },
    searchInvoices() {
      this.fetchInvoices(this.search);
    },
    async setClientBookings() {
      if (this.isNew) {
        if (this.item.client && !this.isCredit && !this.isBlank) {
          var bookings = this.bookings.unallocatedInvoiceItems.filter((b) => {
            return b.client._id == this.item.client._id;
          });

          var bookingItems = bookings.filter((b) => b.bookingType == 0);
          var expenseItems = bookings.filter((b) => b.bookingType == 1);
          var otherItems = bookings.filter((b) => b.bookingType == 2);

          var sorted = bookings.sort(function (a, b) {
            return new Date(a.start) - new Date(b.start);
          });

          if (sorted.length > 0) {
            this.item.start = moment(sorted[0].start)
              .startOf("isoWeek")
              .startOf("day")
              .toISOString();
            this.item.finish = moment(sorted[sorted.length - 1].start)
              .endOf("isoWeek")
              .endOf("day")
              .toISOString();

            var clientInvoices = await this.fetchRecentInvoicesByClient(
              this.item.client._id
            );

            var invoices = clientInvoices.filter((i) => {
              return (
                moment(sorted[0].start).isSameOrAfter(
                  moment(i.start).startOf("day")
                ) &&
                moment(sorted[sorted.length - 1].start).isSameOrBefore(
                  moment(i.finish).endOf("day")
                )
              );
            });

            if (invoices.length > 0) {
              var arr = [...invoices];
              arr.splice(0, 0, {
                invoiceNo: "New",
              });
              this.existingInvoices = arr;
              this.existingInvoice = arr[0];
            } else {
              this.existingInvoices = [];
            }
          }
          this.item = {
            ...this.item,
            dbBookings: bookings,
            bookings: bookingItems.map((b) => {
              return this.bookingDay(b);
            }),
            expenses: expenseItems,
            other: otherItems,
          };
        } else {
          this.item = {
            ...this.item,
            dbBookings: [],
            bookings: [],
            expenses: [],
            other: [],
          };
        }
      }
    },
  },
  activated() {
    this.fetchUnallocatedBookings();
  },
  mounted() {
    this.searchInvoices();
    this.fetchClients();
    this.fetchUnallocatedBookings();
  },
};
</script>
